import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';

import classes from '@nerdwallet/base-styles/classes';
import { Link, Text } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import MarketplaceStarRating from '@nerdwallet/react-marketplace-star-rating';
import Popover from '@nerdwallet/react-popover';
import CCProductImpression from '@nerdwallet/nw-client-lib/lib/tracking/components/cc-product-impression';
import decode from '~/client/lib/render-utils';
import './product-card.less';

const ProductCard = (props) => {
  const {
    data: { product, details },
    position,
    query,
  } = props;

  const legacyId = details.legacy_id.value;

  const truncateLength = 56;

  function truncate(string) {
    if (string.length > truncateLength)
      return `${string.substring(0, truncateLength)} ...`;
    return string;
  }
  const decodedName = decode(product.name);
  const truncatedName = truncate(decodedName);
  const imgSource = get(
    details,
    'image_source_large.value',
    'https://s3.amazonaws.com/cdns3.nerdwallet.com/cc/cc_generic_bw.png'
  );

  const learnMoreUri = setTrk({
    url: `/card-details/card-name/${details.slug.value}`,
    params: {
      trk_query: query,
      trk_position: position,
      trk_product_name: product.name,
    },
  });

  return (
    <CCProductImpression
      id={`search-carousel--${legacyId}`}
      elementName="search-carousel__product_card"
      elementPosition={position}
      elementContent={product.name}
      linkType="hyperlink"
      productId={`${legacyId}`}
      productSlug={details.slug.value}
      productLocation="search-carousel"
    >
      <div
        className={classNames([
          'product-card',
          classes(['text-align-center', 'padding-all-3']),
        ])}
      >
        <Link
          href={setTrk({
            url: learnMoreUri,
            params: {
              [TrkTag.location]: 'search-results__carousel__image',
            },
          })}
        >
          <Image
            src={imgSource}
            alt={get(details, 'image_alt_text.value', decodedName)}
            naturalWidth={140}
            naturalHeight={80}
            backgroundColor="transparent"
            className={classNames([
              'product-card__image',
              classes(['margin-horizontal-auto', 'margin-bottom-3']),
            ])}
          />
        </Link>
        {decode(product.name).length > truncateLength ? (
          <Popover
            type="hover"
            placement="bottom"
            popoverContent={decode(product.name)}
          >
            <Text small bold className={classNames(['product-card__title'])}>
              {truncatedName}
            </Text>
          </Popover>
        ) : (
          <Text small bold className={classNames(['product-card__title'])}>
            {truncatedName}
          </Text>
        )}
        <div className={classes(['margin-vertical-3', 'width-100', 'type-1'])}>
          <MarketplaceStarRating
            marketplaceEntity={props.data}
            ratingTextHref={false}
          />
        </div>
        <Link
          href={setTrk({
            url: learnMoreUri,
            params: {
              [TrkTag.location]: 'search-results__carousel__learn-more',
            },
          })}
          className={classNames(['product-card__learn-link'])}
        >
          Learn More
        </Link>
      </div>
    </CCProductImpression>
  );
};

ProductCard.propTypes = {
  data: PropTypes.shape({
    product: PropTypes.object,
    details: PropTypes.object,
  }),
  query: PropTypes.string,
  position: PropTypes.number,
};

export default ProductCard;
